<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">Agent 管理</h3>

    <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
      <el-form-item label="Agent 名称">
        <el-input v-model.trim="formInline.name" clearable placeholder="请输入 Agent 名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleQuery">查询</el-button>
        <el-button type="primary" @click="handleAdd()">新增 Agent</el-button>
      </el-form-item>
    </el-form>

    <custom-table :data="tableData" ref="table" border style="width: 100%">
      <custom-table-column prop="name" label="Agent 名称" min-width="180">
      </custom-table-column>
      <custom-table-column label="是否流式回复" width="140">
        <template slot-scope="scope">
          <span>{{ scope.row.is_stream == 1 ? '是' : '否' }}</span>
        </template>
      </custom-table-column>
      <custom-table-column prop="role_task" label="角色指令" min-width="360">
      </custom-table-column>
      <custom-table-column prop="created_at" label="创建时间" width="180">
      </custom-table-column>
      <custom-table-column fixed="right" label="操作" width="120">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleEditNew(scope.row, ['id'])">编辑</el-button>
          <el-button type="text" size="small" @click="handleDelet(scope.row.id)">删除</el-button>
        </template>
      </custom-table-column>
    </custom-table>

    <div class="pageLine">
      <PageLine :total="total" ref="pageChild" @getList="getList"></PageLine>
    </div>

    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="620px">
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="120px" class="demo-ruleForm">
        <el-form-item label="Agent 名称" prop="name">
          <el-input v-model.trim="ruleForm.name" maxlength="100" style="width: 432px" placeholder="请输入 Agent 名称"></el-input>
        </el-form-item>
        <el-form-item label="流式数据回复" prop="is_stream">
          <el-switch
            v-model="ruleForm.is_stream"
            :active-value="1"
            :inactive-value="0"
            active-text="是"
            inactive-text="否"
          ></el-switch>
        </el-form-item>
        <el-form-item label="角色指令" prop="role_task">
          <el-input
            v-model.trim="ruleForm.role_task"
            type="textarea"
            style="width: 432px"
            :rows="16"
            maxlength="2000"
            show-word-limit
            placeholder="请输入角色指令"
          ></el-input>
        </el-form-item>
        <el-form-item class="form-footer">
          <el-button type="primary" v-if="type == 'add'" @click="submitFormByFun('ruleForm', createMethod)">
            确定
          </el-button>
          <el-button type="primary" v-if="type == 'edit'" @click="submitFormByFun('ruleForm', updateMethod)">
            保存
          </el-button>
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除该 Agent？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="deleteMethod">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';

export default {
  name: 'agentManage',
  mixins: [mixinList],
  data() {
    return {
      formInline: {
        name: '',
      },
      ruleForm: {
        name: '',
        is_stream: 0,
        role_task: '',
        id: '',
      },
      rules: {
        name: [{ required: true, message: '请输入 Agent 名称', trigger: 'blur' }],
        is_stream: [{ required: true, message: '请选择是否流式回复', trigger: 'change' }],
        role_task: [{ required: true, message: '请输入角色指令', trigger: 'blur' }],
      },
    };
  },
  methods: {
    async getList() {
      const params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      const res = await this.$api.instance.interfaceServer('api/agent/list', 'get', params);
      if (res.code == 0 && res.data) {
        const data = res.data;
        const list = Array.isArray(data)
          ? data
          : data.data || data.list || data.records || [];
        this.tableData = Array.isArray(list) ? list : [];
        this.total = Array.isArray(data) ? this.tableData.length : (data.total || this.tableData.length);
      }
    },

    async createMethod() {
      const params = this.$until.deleteNullPrototype(this.ruleForm);
      delete params.id;
      const res = await this.$api.instance.interfaceServer('api/agent/insert', 'post', params);
      if (res.code == 0) {
        this.$message.success('新增成功');
        this.clearState();
      }
    },

    async updateMethod() {
      const params = this.$until.easyDeepCopy(this.ruleForm);
      const res = await this.$api.instance.interfaceServer('api/agent/save', 'post', params);
      if (res.code == 0) {
        this.$message.success('编辑成功');
        this.clearState();
      }
    },

    async deleteMethod() {
      const res = await this.$api.instance.interfaceServer(`api/agent/delete/${this.delid}`, 'delete', {});
      if (res.code == 0) {
        this.$message.success('删除成功');
        this.dialogVisible = false;
        this.handleQuery();
      }
    },

    handleQuery() {
      this.$refs.pageChild.page = 1;
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}

.form-footer {
  margin-top: 8px;
  text-align: right;
}
</style>
